import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import authUtils from '../../auth/utils';
import { loadHolidaysByCenterAndTerm, createCenterHoliday, updateCenterHoliday, deleteCenterHoliday } from './actions';
import List from './List';
import SettingForm from './SettingsForm';
import Dialog from '../../common/components/Dialog';
import ui from '../../common/services/ui';
import CollapsablePanel from '../../common/components/CollapsablePanel';
import { FormControl, Button } from 'react-bootstrap';
import RemoteSubmitButton from '../../common/components/formControls/RemoteSubmitButton';
import TermsDropdownList from '../terms/DropdownList';
import { withTranslation } from 'react-i18next';
import { faCalendarDays } from '@fortawesome/free-regular-svg-icons';
import { faCheck } from '@fortawesome/free-solid-svg-icons';

class CenterHolidays extends Component {
	constructor(props) {
		super(props);
		this.handleListEvent = this.handleListEvent.bind(this);
		this.hideHolidayDialog = this.hideHolidayDialog.bind(this);
		this.showHolidayDialog = this.showHolidayDialog.bind(this);
		this.handleHolidaySave = this.handleHolidaySave.bind(this);
		this.handleDelete = this.handleDelete.bind(this);
		this.handleSendHolidayReminderChange = this.handleSendHolidayReminderChange.bind(this);
		this.handleIsHolidayChange = this.handleIsHolidayChange.bind(this);

		this.state = {
			termId: null,
			showHolidayDialog: false
		};
	}

	handleListEvent(listPagination) {
		const centerId = this.props.centerId;
		const { termId } = this.state;

		this.props.loadData({ centerId, termId, ...listPagination });
	}

	handleHolidayTermChange(termId, centerId) {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		this.setState({ termId: termId });
		this.props.loadData({ centerId, termId, sortKey, sortDirection, pageNumber, pageSize });
	}

	dialogConfig() {
		const { t, ...rest } = this.props;
		const { holiday, termId } = this.state;
		let initialValues = holiday;

		if (!initialValues) {
			initialValues = { termId: termId, skipWeek: true };
		}

		return {
			header: t('CenterHoliday_EditHoliday'),
			body: <SettingForm onSubmit={this.handleHolidaySave} initialValues={initialValues} termId={termId} centerId={this.props.centerId}
				onSendHolidayReminderChange={this.handleSendHolidayReminderChange} sendHolidayReminder={this.state.sendHolidayReminder}
				onIsHolidayChange={this.handleIsHolidayChange} isHoliday={this.state.isHoliday} {...rest} />,
			onHide: () => this.hideHolidayDialog(),
			footer: this.renderHolidayDialogFooter()
		};
	}

	handleSendHolidayReminderChange(event, sendHolidayReminder) {
		this.setState({ sendHolidayReminder });
	}

	handleIsHolidayChange(event, isHoliday) {
		this.setState({ isHoliday });
	}

	hideHolidayDialog() {
		this.setState({ showHolidayDialog: false });
	}

	showHolidayDialog(holiday) {
		this.setState({
			sendHolidayReminder: holiday && holiday.sendHolidayReminder,
			isHoliday: holiday && holiday.isHoliday
		});
		this.setState({ showHolidayDialog: true, holiday });
	}

	onSuccessSaveEvent() {
		this.hideHolidayDialog();
		this.reloadData();
	}

	reloadData() {
		const { sortKey, sortDirection, pageNumber, pageSize } = this.props.pagination;
		const { termId } = this.state;
		const { centerId } = this.props;
		this.props.loadData({ centerId, termId, sortKey, sortDirection, pageNumber, pageSize });
	}

	handleHolidaySave(values) {
		const { holiday } = this.state;
		const { createCenterHoliday, updateCenterHoliday, centerId } = this.props;

		const onSuccessEvent = () => this.onSuccessSaveEvent();
		if (holiday) {
			updateCenterHoliday(holiday.id, values, onSuccessEvent);
		}
		else
		{
			values.centerId = centerId;
			createCenterHoliday(values, onSuccessEvent);
		}
	}

	handleDelete(id) {
		const onSuccessEvent = () => this.reloadData();
		this.props.deleteCenterHoliday(id, onSuccessEvent);
	}

	renderHolidayDialogFooter() {
		const t = this.props.t;
		const closeBtn = <Button key='closeBtn' onClick={this.hideHolidayDialog}>{t('Common_Close')}</Button>;
		const saveBtn = <RemoteSubmitButton key='saveBtn' style='success' formName='centerHoliday' label={t('Common_Save')} icon={faCheck} />;
		return [closeBtn, saveBtn];
	}

	render() {
		const { centerId, t, isReadonly } = this.props;
		
		const dialogConfig = this.dialogConfig();
				
		return (
			<CollapsablePanel icon={faCalendarDays} title={t('CenterHoliday_Holidays')} collapsed>
				<Dialog config={dialogConfig} show={this.state.showHolidayDialog} />
				<TermsDropdownList defaultSelection='active' value={this.state.termId} onChange={(termId) => this.handleHolidayTermChange(termId, centerId)} emptyLabel={t('Center_ChooseTerm')} centerId={centerId} />
				<List data={this.props.data} {...this.props.pagination} onClick={this.showHolidayDialog} onFetchData={this.handleListEvent} onDelete={this.handleDelete} isReadonly={isReadonly} />
			</CollapsablePanel>
		);
	}
}

const mapStateToProps = (state, ownProps) => {
	const centerId = ownProps.centerId;

	const {
		pagination,
		entities: { centerHolidays },
		auth: { currentUser }
	} = state;

	const centerHolidaysPagination = pagination.centerHolidays[centerId] || { ids: [], pageNumber: 1, pageSize: 10 };


	return {
		centerId,
		data: centerHolidaysPagination.ids.map(id => centerHolidays[id]),
		pagination: centerHolidaysPagination,
		isReadonly: authUtils.hasReadOnlyPermission(currentUser, 'Franchisees')		
	};
};

CenterHolidays.propTypes = {
	centerId: PropTypes.number.isRequired
};

export default connect(mapStateToProps, {
	loadData: loadHolidaysByCenterAndTerm,
	createCenterHoliday,
	updateCenterHoliday,
	deleteCenterHoliday,
})(withTranslation()(CenterHolidays));